import { createFileRoute } from "@tanstack/react-router";
import {
	drawerFormSearch,
	redirectLegacyEntityTypeForm,
} from "@/features/form-editor/lib/redirect-legacy-entity-type-form";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/assetTypes/$assetTypeId/form" as const;

export const Route = createFileRoute(ROUTE_ID)({
	beforeLoad: ({ location, params, search }) => {
		redirectLegacyEntityTypeForm({
			pathname: location.pathname,
			typeId: params.assetTypeId,
			to: "/org-admin/$orgId/configuration/assetTypes/$assetTypeId/schema",
			params: { orgId: params.orgId, assetTypeId: params.assetTypeId },
			search: drawerFormSearch(search, "drawer"),
		});
	},
	component: () => null,
});
